import React from 'react';
import uuidv4 from 'uuid';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
//import { Tooltip, Fade } from '@material-ui/core';

import { getDescr } from '../../../reducers/reducer_motivo';

const styles = theme => ({
    root: {
        height: '100%',
        width: 240
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 300,
    },
    buttonsContainer: {
        width: 520,
        padding: '25px 0 0 25px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
});

class EditCvMotivo extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            id: this.props.motivo.id ? this.props.motivo.id : uuidv4(),
            description: this.props.motivo.descr ? this.props.motivo.descr : '',
            iKind: this.props.motivo.iKind ? this.props.motivo.iKind : 1,
            kindDescr:  getDescr(this.props.motivo.iKind),
        };

    };

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };

    handleChangeSelect = event => {

        const value = parseInt(event.target.value);

        this.setState({
            ...this.state,
            iKind: value,
            kindDescr: getDescr(value),
        });
    };


    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="tipo-promocion-placeholder">
                            Tipo Motivo
                    </InputLabel>
                        <Select
                            native
                            value={this.state.iKind}
                            onChange={(event) => this.handleChangeSelect(event)}
                        >
                            <option value={1}>{getDescr(1)}</option>
                            <option value={2}>{getDescr(2)}</option>
                        </Select>
                    </FormControl>
                </div>
                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <TextField
                            id={'description'}
                            label={'Descripción'}
                            placeholder={'Descripción'}
                            margin="normal"
                            //autoFocus
                            value={this.state.description}
                            onChange={(event) => this.handleValueChange(event, 'description')}
                        />
                    </FormControl>
                </div>

                <div className={classes.buttonsContainer}>
                    <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={() => this.props.hideDialog()}>Cerrar</Button>
                    <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                        const motivo = {
                            id: this.state.id,
                            descr: this.state.description,
                            iKind: this.state.iKind,
                            kindDescr : this.state.kindDescr,
                        }

                        if (this.props.checkMotivo(motivo)) {
                            this.props.okHandler(motivo);
                            this.props.hideDialog();
                        }
                    }
                    }>Guardar</Button>
                </div>
            </div>
        );
    };

};

EditCvMotivo.propTypes = {
    motivo: PropTypes.object.isRequired,
    checkMotivo: PropTypes.func.isRequired,
    okHandler: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
};


export default withStyles(styles, { withTheme: true })(EditCvMotivo);